const roster = [
  {
    name: "Shower",
    slug: "shower",
    displayName: "SHOWER",
    aliases: ["SHOWER", "Shower", "shower", "שאוור"],
    bio: "SHOWER blurs the lines between melodic trap and experimental hip-hop, fusing slick vocal delivery with emotional depth.",
    image: "https://is1-ssl.mzstatic.com/image/thumb/AMCArtistImages221/v4/07/c6/e5/07c6e576-9209-6826-9e50-26344cde6f14/file_cropped.png/1000x1000bb.jpg",
    releasesLink: "/releases?artist=Shower",
    socials: {
      instagram: "https://www.instagram.com/showerbitch",
      spotify: "https://open.spotify.com/artist/4e3UN55UMINH761mfPBRap?si=zbTASMBgS0SpeLgHJ-MGyg",
      appleMusic: "https://music.apple.com/il/artist/adam-in-the-shower/1463446987?l=he",
      tiktok: "https://www.tiktok.com/@showerbih",
      youtube: "https://www.youtube.com/channel/UClxqI3whK3DF6F4W4Q9hO7A",
    }
  },
  {
    name: "YALi",
    slug: "yali",
    displayName: "YALi",
    aliases: ["YALi", "YALI", "yali", "יהלי"],
    bio: "YALi (יהלי) is a singer-songwriter blending hip-hop, pop, and electronic sounds with Mediterranean and global influences.",
    image: "https://i.postimg.cc/BZ1q4xQM/temp-Imagen-QRo-Pk.avif",
    releasesLink: "/releases?artist=YALi",
    socials: {
      instagram: "https://www.instagram.com/yalzzii/",
      spotify: "https://open.spotify.com/artist/3mI1CyAI1IOTGRYqXfX5fT?si=ANlgaFsIRpaJdq2qrgaz0g",
      appleMusic: "https://music.apple.com/il/artist/%D7%99%D7%94%D7%9C%D7%99/1700488305?l=he",
      tiktok: "https://www.tiktok.com/@yalzzii",
      youtube: "https://www.youtube.com/watch?v=hRo2y0U-N_k"
    }
  },
  {
    name: "Sighdafekt",
    slug: "sighdafekt",
    displayName: "Sighdafekt",
    aliases: ["Sighdafekt", "sighdafekt", "SIGHDAFEKT", "סיידאפקט"],
    bio: "Sighdafekt, also known as Dave Slagorsky, bridges Israeli hip-hop and international production styles with emotionally raw, high-concept releases.",
    image: "https://is1-ssl.mzstatic.com/image/thumb/AMCArtistImages221/v4/e8/f7/3c/e8f73c64-5e0b-ce16-bdf0-ec0308931ff8/7f8a5081-38ab-4b07-a23f-87c3dea38270_file_cropped.png/1000x1000bb.jpg",
    releasesLink: "/releases?artist=Sighdafekt",
    socials: {
      instagram: "https://instagram.com/imsigh",
      spotify: "https://open.spotify.com/artist/58luIRW1Niu35QbYozFjPj?si=jUHv2RiORH2hE4F9r2N3Fg",
      appleMusic: "https://music.apple.com/il/artist/sighdafekt/692853131?l=he",
      tiktok: "https://www.tiktok.com/@sighdafekt"
    }
  },
  {
    name: "Ethel",
    slug: "ethel",
    displayName: "Ethel",
    aliases: ["Ethel", "ethel", "ETHEL", "אתל"],
    bio: "Ethel blends dreamy alt-pop and intimate vocals with experimental textures, creating soundscapes that are both fragile and powerful.",
    image: "https://iili.io/F4WKPzg.png",
    releasesLink: "/releases?artist=Ethel",
    socials: {
      instagram: "https://instagram.com/ethel_superstarbaby",
      spotify: "https://open.spotify.com/artist/1PkYjaCMjQO2A4Jotcar2V?si=yd6uZJmxQhCytO6jMKUwrw",
      appleMusic: "https://music.apple.com/il/artist/%D7%90%D7%AA%D7%9C/1492747095?l=he",
      tiktok: "https://www.tiktok.com/@ethel_superstarbaby"
    }
  },
  {
    name: "רומי רוט",
    slug: "romiroth",
    displayName: "ROMI ROTH",
    aliases: ["רומי רוט", "Romi Roth", "ROMI ROTH", "Romi"],
    bio: "Romi Roth is an alternative rock artist blending raw emotion with melodic intensity. Her music balances grit and sensitivity, driven by honest songwriting and a modern indie edge.",
    image: "https://i.postimg.cc/CxZ8kfrM/520820584-18509610442017331-6655838734014150963-n.jpg",
    releasesLink: "/releases?artist=רומי רוט",
    socials: {
      instagram: "https://www.instagram.com/romi_roth/",
      spotify: "https://open.spotify.com/artist/0Z8PiPMaNbBF1wIht8qmNv?si=cKmAj-u-StGBKd05tDFE0g",
      appleMusic: "https://music.apple.com/il/artist/%D7%A8%D7%95%D7%9E%D7%99-%D7%A8%D7%95%D7%98/1835259399?l=he",
      tiktok: "https://www.tiktok.com/@romi_roth",
      youtube: "https://www.youtube.com/@romi_roth"
    }
  },
  {
    name: "Alon Mylo",
    slug: "alonmylo",
    displayName: "Alon Mylo",
    aliases: ["Alon Mylo", "alon mylo", "AlonMylo"],
    bio: "Alon Mylo is a genre-defying artist whose music bridges alt-pop, hip-hop, and electronic soundscapes. Guided by his synesthetic perception of sound as color, he crafts immersive works that invite audiences into a vibrant, boundary-breaking world.",
    image: "https://i.imgur.com/CqaN85O.jpeg",
    releasesLink: "/releases?artist=Alon Mylo",
    socials: {
      instagram: "https://www.instagram.com/alonmylo/",
      spotify: "https://open.spotify.com/artist/7eA0BzIcfh0boxSZkHivNM?si=zjB6UfAvSsGN3NUxl9px9A",
      appleMusic: "https://music.apple.com/il/artist/alon-mylo/1629238483?l=he",
      tiktok: "https://www.tiktok.com/@spaceprincepope",
      youtube: "https://www.youtube.com/@Alonmylo"
    }
  },
  {
    name: "Kizels",
    slug: "kizels",
    displayName: "Kizels",
    aliases: ["Kizels", "kizels", "KIZELS"],
    bio: "Kizels creates lo-fi rap and ambient soundscapes, combining streetwise lyrics with dreamy, minimal production.",
    image: "https://iili.io/F4VyakJ.md.jpg",
    releasesLink: "/releases?artist=Kizels",
    socials: {
      instagram: "https://instagram.com/kizels",
      spotify: "https://open.spotify.com/artist/0ZxV3yaIkex9CDaP43WhuY?si=4PhYoLG2R7-9fimeGRJs7Q",
      appleMusic: "https://music.apple.com/il/artist/kizels/1257722331?l=he",
      tiktok: "https://www.tiktok.com/@kizels",
      youtube: "https://www.youtube.com/channel/UC7ma1m68GZoy7STYPAwgmYQ"
    }
  },
  {
    name: "רוי ניסמו",
    slug: "roynismo",
    displayName: "Roy Nismo",
    aliases: ["רוי ניסמו", "Roy Nismo", "roy nismo", "ROY NISMO", "Roy"],
    bio: "Melancholic hip-hop from Israel blending lo-fi trap with raw emotion. For fans of $uicideboy$ and dark, introspective vibes.",
    image: "https://i.scdn.co/image/ab6761610000e5eb857ad2aa383c67f4c04488da",
    releasesLink: "/releases?artist=רוי ניסמו",
    socials: {
      instagram: "https://www.instagram.com/roynismo_/",
      spotify: "https://open.spotify.com/artist/6BneFQrxc97112ZGRaO5Cs?si=zWSZXrohRyySl1ERxzGznQ",
      appleMusic: "https://music.apple.com/il/artist/%D7%A8%D7%95%D7%99-%D7%A0%D7%99%D7%A1%D7%9E%D7%95/1774740610?l=he",
      youtube: "https://www.youtube.com/@roynismo_yt"
    }
  },
  {
    name: "אלוני",
    slug: "aloni",
    displayName: "ALONI",
    aliases: ["אלוני", "ALONI", "Aloni", "aloni"],
    bio: "ALONI blends modern trap production with an effortless, confident delivery. His music lives in the space between sharp minimalism and emotional honesty, driven by atmosphere, flow, and subtle intensity.",
    image: "https://i.postimg.cc/WbkMDH96/3f4f9b29e6ad69f0714de9c1bb8a0c6f-1000x1000x1.jpg",
    releasesLink: "/releases?artist=אלוני",
    socials: {
      instagram: "https://www.instagram.com/_al0ni/",
      spotify: "https://open.spotify.com/artist/1O9j7fwUrhSRJ0dbW9fDGV?si=vrjA6iGFSsGomwco2r5XsA",
      appleMusic: "https://music.apple.com/il/artist/%D7%90%D7%9C%D7%95%D7%A0%D7%99/1630644230?l=he",
      tiktok: "https://www.tiktok.com/@aloni8745",
      youtube: "https://www.youtube.com/@aloni-n9d"
    }
  },
  {
    name: "E$H",
    slug: "esh",
    displayName: "E$H",
    aliases: ["E$H", "esh", "ESH", "Maor Bezalel", "maor bezalel", "אש", "א$ה", "א$"],
    bio: "E$H (f.k.a Maor Bezalel) is a Tel Aviv producer & artist — versatile, uncompromising, and built on quality, honesty, and real-life lyricism.",
    image: "https://i.postimg.cc/NfSFN3t8/6D79D7DC-F40B-496F-9FE2-6379C854F4B4.jpg",
    releasesLink: "/releases?artist=E$H",
    socials: {
      instagram: "https://www.instagram.com/eshpapi_/",
      spotify: "https://open.spotify.com/artist/4B7bhF9L9kqZzctMidsySA?si=QY-4XGOmQE-Su8iCiM2VPA",
      tiktok: "https://www.tiktok.com/@eshpapichulo",
      youtube: "https://www.youtube.com/channel/UCKko4zNZRyDXN2shcnLY3Pg"
    }
  },
  {
    name: "COCO",
    slug: "coco",
    displayName: "COCO",
    aliases: ["COCO", "Coco", "coco", "קוקו"],
    bio: "COCO blends rap and melody into a bold signature — strong, feminine, and unapologetically honest.",
    image: "https://i.postimg.cc/LX9jHcnT/channels4-profile.jpg",
    releasesLink: "/releases?artist=coco",
    socials: {
      instagram: "https://www.instagram.com/_itscoco__/",
      spotify: "https://open.spotify.com/artist/6BxwlMx56pRg0qDoaZLNWb?si=qV73Gs0ySDCRxzzcQY-WCA",
      appleMusic: "https://music.apple.com/il/artist/coco/1880456394?l=he",
      youtube: "https://www.youtube.com/@its-coco-x"
    }
  },
  {
    name: "בן דן",
    slug: "bendan",
    displayName: "Ben Dan",
    aliases: ["Ben Dan", "ben dan", "BEN DAN", "בן דן", "bendastic"],
    bio: "",
    image: "https://i.postimg.cc/rmm5LkTy/BEN-DAN-PRESS-PIC-1.jpg",
    releasesLink: "/releases?artist=בן דן",
    socials: {
      instagram: "https://www.instagram.com/bendastic/",
      tiktok: "https://www.tiktok.com/@bendastic",
      youtube: "https://www.youtube.com/@omerbendan",
    }
  },
  {
    name: "סגולות",
    slug: "sgulot",
    displayName: "SGULOT",
    aliases: ["סגולות", "Sgulot", "SGULOT", "sgulot"],
    bio: "A rap duo from Haifa, Sgulot blends sharp Hebrew bars with dusty beats and experimental textures. Members Adi Yonatan Cohen and Ofer Yarkoni bring lyrical depth and raw energy to every track.",
    image: "https://i.scdn.co/image/ab6761610000e5eb912bae37f837455d83f1d2e1",
    releasesLink: "/releases?artist=סגולות",
    socials: {
      instagram: "https://www.instagram.com/_sgulot_/",
      spotify: "https://open.spotify.com/artist/3BlucB5OjMUQc224bADi5s?si=ncLSUnjuRya94DxNdceYIg",
      appleMusic: "https://music.apple.com/il/artist/%D7%A1%D7%92%D7%95%D7%9C%D7%95%D7%AA/1678857464?l=he"
    }
  }
];

export default roster;
